import { render, staticRenderFns } from "./createBaseInfo.vue?vue&type=template&id=70dc2e92"
import script from "./createBaseInfo.vue?vue&type=script&lang=js"
export * from "./createBaseInfo.vue?vue&type=script&lang=js"
import style0 from "./createBaseInfo.vue?vue&type=style&index=0&id=70dc2e92&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports